import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import history from "../../../../history";
import { cekCookies } from "../../../../actions";
import __ from "lodash";
import Loader from "../../../Loader";
import LoaderModal from "../../../modal/LoaderModal";
import Navbar from "../../navbar/Navbar";
import Sidebar from "../../sidebar/Sidebar";
import { CONFIG, URL_AKM } from "../../../../config";
import akmApi from "../../../../apis/akmApi";
import accountManagement from "../../../../apis/accountManagement";
import FilterSoal from "../../../../entity/FilterSoal";
import DropdownKelas from "../masterDropDown/DropdownKelas";
import DropdownMapel from "../masterDropDown/DropdownMapel";
import DropdownTipeSoal from "../masterDropDown/DropdownTipeSoal";
import DropdownUploadHistory from "../masterDropDown/DropdownUploadHistory";
import DropdownUploadHistoryAsync from "./DropdownUploadHistoryAsync";
import { Row, Col, Alert } from "react-bootstrap";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import PaginationData from "../../../../entity/PaginationData";
import PaginationTable from "../masterDropDown/PaginationTable";
import Select from "react-select";
import IndicatorMetadata from "./IndicatorMetadata";
import "./indicatorImport.css";

class MgtSoalAkm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathname: this.props.location.pathname,
      listSoal: [],
      listKelas: [],
      listMapel: [],
      listTipeSoal: [],
      uploadHis: [],
      filterSoalSeach: FilterSoal,
      paginationData: PaginationData,
      isFetching: false,
      isSearch: false,
      showAlert: false,
      resMessage: {},
    };
  }
  async componentDidMount() {
    this.setState({ isFetching: true });
    await this.props.cekCookies();
    if (!__.isEmpty(this.props.account)) {
      this.fetchKelas();
      this.fetchTipeSoal();
      this.fetchUploadHis();

      if (this.props.location.state != undefined) {
        const idKelas = this.props.location.state.params.idKelas;
        this.setState({
          filterSoalSeach: {
            ...this.state.filterSoalSeach,
            idKelas: idKelas,
            idMataPelajaran: this.props.location.state.params.idMataPelajaran,
            tipeSoal: this.props.location.state.params.tipeSoal,
            idUploadHistory: this.props.location.state.params.idUploadHistory,
          },
        });
        if (idKelas !== null) {
          this.fetchMapel(idKelas);
        }
        this.fetchSoal();
      }
    }

    this.setState({ isFetching: false });
  }

  fetchKelas = async () => {
    this.setState({ isFetching: true });
    const response = await akmApi.get(URL_AKM.KELAS_ALL).catch(function (error) {
      this.setState({ showAlert: true, resMessage: error });
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listKelas: response.data.data,
        });
      } else {
        this.setState({
          listKelas: [],
          showAlert: true,
          resMessage: "Kelas " + response.data.errorSchema.errorMessage,
        });
      }
      this.setState({ isFetching: false });
    }
  };

  fetchMapel = async (idKelas) => {
    this.setState({ showAlert: false });
    const response = await akmApi.get(URL_AKM.MAPEL_GET_BY_IDKELAS + idKelas).catch(function (error) {
      this.setState({ showAlert: true, resMessage: error });
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listMapel: response.data.data,
        });
      } else {
        this.setState({
          listMapel: [],
          showAlert: true,
          resMessage: "Mapel " + response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  fetchTipeSoal = async () => {
    const response = await akmApi.get(URL_AKM.GET_TIPE_SOAL).catch(function (error) {
      this.setState({ showAlert: true, resMessage: error });
    });
    if (response) {
      if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listTipeSoal: response.data.data,
        });
      } else {
        this.setState({
          listTipeSoal: [],
          showAlert: true,
          resMessage: response.data.errorSchema.errorMessage,
        });
      }
    }
  };

  handleChangeKelas = async (event) => {
    const { value } = event.target;
    if (value === "") {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, idKelas: null } });
    } else {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, idKelas: value, idUploadHistory: null } });
      this.fetchMapel(value);
    }
  };
  handleChangeMapel = async (event) => {
    const { value } = event.target;
    if (value === "") {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, idMataPelajaran: null, idTematik: null } });
    } else {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, idMataPelajaran: value, idTematik: null, idUploadHistory: null } });
    }
  };
  handleChangeTipe = async (event) => {
    const { options, selectedIndex, value } = event.target;
    if (value === "") {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, tipeSoal: null, keterangan: null } });
    } else {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, tipeSoal: value, keterangan: options[selectedIndex].innerHTML } });
    }
  };
  handleChangeUpHis = async (idUploadHistory) => {
    // const name = e.id;
    // const id = e.value;
    // this.setState({
    //   [e.id]: id,
    // });

    if (idUploadHistory === "") {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, idUploadHistory: null } });
    } else {
      this.setState({ filterSoalSeach: { ...this.state.filterSoalSeach, idKelas: null, idMataPelajaran: null, idUploadHistory: idUploadHistory } });
    }
  };

  async fetchUploadHis(keterangan) {
    const result = await akmApi
      .post(URL_AKM.POST_UPLOAD_HISTORY_ID, {
        idAdmin: this.props.account.idAdmin,
        keterangan: keterangan,
      })
      .catch(function (error) {
        console.log(error);
      });

    if (result) {
      let uploadHistory = [];
      const data = { value: "", label: "Pilih Jadwal...", id: "idUploadHistory", selected: "selected" };
      uploadHistory.push(data);
      result.data.data.map((val, i) => {
        const data = { value: val.idUploadHistory, label: val.keterangan, id: "idUploadHistory" };
        uploadHistory.push(data);
      });
      // if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
      //     uploadHistory = result.data.data;
      // }

      this.setState({ uploadHis: uploadHistory });
    }
  }

  fetchSoal = async () => {
    this.setState({ isFetching: true });
    const result = await akmApi.post(URL_AKM.BANK_SOAL_LIST, this.state.filterSoalSeach, { params: { page: this.state.paginationData.page, size: this.state.paginationData.size } });
    if (result) {
      if (result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({
          listSoal: result.data.data.content,
          paginationData: {
            ...this.state.paginationData,
            page: result.data.data.number,
            size: result.data.data.size,
            totalPages: result.data.data.totalPages,
            numberOfElements: result.data.data.numberOfElements,
            totalElements: result.data.data.totalElements,
          },
        });
      } else {
        this.setState({
          listSoal: [],
          paginationData: PaginationData,
          showAlert: true,
          resMessage: result.data.errorSchema.errorMessage,
        });
      }
      this.setState({ isFetching: false });
    }
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "/vendor/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";

      var config = "MathJax.Hub.Config({" + 'extensions: ["tex2jax.js"],' + 'jax: ["input/TeX","output/HTML-CSS"]' + "});" + "MathJax.Hub.Startup.onload();";

      if (window.opera) {
        script.innerHTML = config;
      } else {
        script.text = config;
      }

      script.addEventListener("load", function () {
        if (window.MathJax && window.MathJax.Hub) window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], "");
      });

      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  };
  handleChangePage = async (newPage) => {
    this.state.paginationData.page = newPage;
    this.fetchSoal();
  };

  handleChangeRowsPerPage = (size) => {
    this.state.paginationData.page = 0;
    this.state.paginationData.size = size;
    this.fetchSoal();
  };

  handleButtonTampil = async () => {
    this.fetchSoal();
  };
  handleAddSoal = () => {
    const params = this.state.filterSoalSeach;
    if (params.tipeSoal === null) {
      return alert("Wajib Memilih Tipe Soal ...");
    }

    history.push({
      pathname: "/addsoal",
      state: { params: this.state.filterSoalSeach, soal: {} },
    });
  };
  handleEditSoal = (soal) => {
    const params = this.state.filterSoalSeach;
    history.push({
      pathname: "/addsoal",
      state: {
        params: {
          ...params,
          idBankSoal: soal.idBankSoal,
          idKelas: soal.idKelas,
          idMataPelajaran: soal.idMataPelajaran,
          idTematik: soal.idTematik,
          idUploadHistory: soal.idUploadHistory,
          tipeSoal: soal.tipeSoal,
          keterangan: soal.tipeSoal,
        },
        soal: soal,
        fromUrl: this.state.pathname,
      },
    });
    console.clear();
    console.log(params);
    console.log(soal);
  };

  renderBobot(value) {
    if (value === "1") {
      return "Mudah";
    } else if (value === "2") {
      return "Sedang";
    } else if (value === "3") {
      return "Sulit";
    } else if (value === "4") {
      return "Sangat Sulit";
    } else {
      return "Sangat Mudah";
    }
  }

  renderSoal() {
    return (
      <React.Fragment>
        {this.state.listSoal.map((soal) => (
          <TableRow key={soal.idBankSoal}>
            <TableCell align="left">{soal.idBankSoal}</TableCell>
            <TableCell align="left" dangerouslySetInnerHTML={{ __html: soal.pertanyaan }}></TableCell>
            <TableCell align="center">{soal.tipeSoal}</TableCell>
            <TableCell align="center">{this.renderBobot(soal.mudahSulit)}</TableCell>
            <TableCell align="right">
              <div className="button-group">
                <button className="btn btn-warning btn-sm" onClick={() => this.handleEditSoal(soal)}>
                  <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                </button>
                &nbsp;
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => {
                    if (window.confirm("Yakin Hapus Soal ?")) this.onDelete(soal.idBankSoal);
                  }}
                >
                  <i className="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </React.Fragment>
    );
  }

  onDelete = async (id) => {
    this.setState({ isFetching: true });
    const res = await accountManagement.delete(CONFIG.SOAL_DELETE_BY_ID + id).catch(function (error) {
      console.log(error);
    });
    if (res) {
      if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
        this.setState({ listSoal: this.state.listSoal.filter((item) => item.idBankSoal !== id) });
      } else {
        this.setState({ showAlert: true, resMessage: res.data.errorSchema.errorMessage });
      }
      this.setState({ isFetching: false });
    }
  };

  render() {
    const { filterSoalSeach, pathname } = this.state;
    return (
      <div className="wrapper">
        <LoaderModal isFetching={this.state.isFetching} />
        <Sidebar account={this.props.account} />
        <div id="content" style={{ paddingBottom: "50px" }}>
          <Navbar title="Management Soal" />
          {this.renderAlert()}
          <Row>
            
              <Fragment>
                <Col>
                  <div className="form-group">
                    <select className="form-control" name="kelas" id="kelas" value={filterSoalSeach.idKelas || ""} onChange={this.handleChangeKelas}>
                      <option value="">Pilih Kelas...</option>
                      <DropdownKelas kelas={this.state.listKelas} />
                    </select>
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <select className="form-control" name="mapel" id="mapel" value={filterSoalSeach.idMataPelajaran || ""} onChange={this.handleChangeMapel}>
                      <option value="">Pilih Mapel...</option>
                      <DropdownMapel mapel={this.state.listMapel} />
                    </select>
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <select className="form-control" name="tipe" id="tipe" value={filterSoalSeach.tipeSoal || ""} onChange={this.handleChangeTipe}>
                      <option value="">Pilih Tipe Soal...</option>
                      <DropdownTipeSoal tipeSoal={this.state.listTipeSoal} />
                    </select>
                  </div>
                </Col>
              </Fragment>
            
            <Col>
              {/* <div className="form-group">                                    
                                <select className="form-control" name="uphis" id="uphis" 
                                    value={filterSoalSeach.idUploadHistory || ""}
                                    onChange={this.handleChangeUpHis} >
                                    <option value="">Pilih Up His...</option>
                                    <DropdownUploadHistory uploadHis={this.state.uploadHis} />                                    
                                </select>
                            </div> */}

              {/* <Fragment>
                <Select name="uphis" options={this.state.uploadHis} onChange={this.handleChangeUpHis} placeholder="Pilih Upload History..." />
                <input tabIndex={-1} autoComplete="off" style={{ opacity: 0, height: 0 }} value={filterSoalSeach.idUploadHistory || ""} required />
              </Fragment> */}
              <DropdownUploadHistoryAsync idAdmin={this.props.account.idAdmin} handleChangeUpHis={(idUploadHistory) => this.handleChangeUpHis(idUploadHistory)} />
            </Col>
            <Col>
              <Button variant="contained" color="primary" onClick={() => this.handleButtonTampil()}>
                Tampilkan{" "}
              </Button>
            </Col>
            <Col>
              <Button className="pull-right" variant="contained" color="primary" onClick={() => this.handleAddSoal()} startIcon={<CloudUploadIcon />}>
                Tambah Soal
              </Button>
            </Col>
          </Row>

          <details className="indicator-workflow" style={{ padding: 0 }}><summary className="btn btn-outline-secondary my-3">Periksa dan petakan indikator paket</summary><IndicatorMetadata account={this.props.account} history={this.props.history} idUploadHistory={filterSoalSeach.idUploadHistory} /></details>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">ID</TableCell>
                  <TableCell align="left">Pertanyaan</TableCell>
                  <TableCell align="center">Tipe</TableCell>
                  <TableCell align="center">Bobot</TableCell>
                  <TableCell align="right">#</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{this.renderSoal()}</TableBody>
            </Table>
            <PaginationTable paging={this.state.paginationData} handleChangePage={this.handleChangePage} handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
          </TableContainer>
        </div>
      </div>
    );
  }
  loading = () => {
    if (this.state.isSearch) {
      return <Loader />;
    }
  };
  renderAlert = () => {
    const { showAlert, resMessage } = this.state;

    if (showAlert) {
      return (
        <Alert variant="info" onClose={() => this.setState({ showAlert: false })} dismissible>
          <strong>{resMessage}</strong>
        </Alert>
      );
    }
  };
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
  };
};

export default connect(mapStateToProps, { cekCookies })(MgtSoalAkm);
